import { localizedLegalPage } from "./localized";
import { SecurityDisclosurePage as Fr } from "./fr/SecurityDisclosurePage";
import { SecurityDisclosurePage as En } from "./en/SecurityDisclosurePage";

export const SecurityDisclosurePage = localizedLegalPage({ fr: Fr, en: En });

export default SecurityDisclosurePage;
